import React from "react";
import { Row, Col } from "react-bootstrap";

import { waterSystemStatus, waterSystemRating } from "../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";

const SystemHeaderRibbon = ({ systemHeaderView }) => {
  return (
    <Row className="mb-3">
      <Col xs lg="6" className="m-0 p-0">
        <ul className="horizontal-list ribbon name-background" cypressid="header-ribbon">
          <li>
            <span className="text-uppercase"> {systemHeaderView.systemName} </span>
          </li>
          <li className="float-end">
            <span>PWS ID:</span>
            <span> {systemHeaderView.pwsId}</span>
          </li>
        </ul>
      </Col>
      {systemHeaderView.rating ? (
        <Col className="m-0 p-0">
          <ul className={`horizontal-list ribbon rating-${systemHeaderView.rating.toLowerCase()}`}>
            <li>
              <span>Rating: </span>
              <span> {systemHeaderView.rating !== null ? waterSystemRating[systemHeaderView.rating] : ""}</span>
            </li>
            <li>
              <span>
                {systemHeaderView.ratingDate !== null ? convertTimeStampToDate(systemHeaderView.ratingDate) : ""}
              </span>
            </li>
            <li className="float-end">
              <span>Status: </span>
              <span> {systemHeaderView.status !== null ? waterSystemStatus[systemHeaderView.status] : ""}</span>
            </li>
          </ul>
        </Col>
      ) : (
        <Col className="m-0 p-0">
          <ul className={`horizontal-list ribbon rating-none`}>
            <li>
              <h5>Rating: </h5>
            </li>
            <li />
            <li>
              <h5>Status: </h5>
              <span> {systemHeaderView.status !== null ? waterSystemStatus[systemHeaderView.status] : ""}</span>
            </li>
          </ul>
        </Col>
      )}
    </Row>
  );
};

export default SystemHeaderRibbon;
